<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <Filter
                            :sns="false"
                            :type="false"
                            :resultType="false"
                            :resultDetailType="false"
                            :nation="false"
                            :isMonitoring="false"
                            :platform="true"
                            :dateRange="false"
                            :gubun="true"
                            :industry="true"
                            :selectOption="state.selectOption"
                            @search="filterSearch"
                            @reset="resetSearch"
                        ></Filter>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn" @click="toggleAll">전체선택</button>
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" />
                                </button>
                            </div>
                            <div class="board_top_btns_right">
                                <div class="count">{{ state.totalLength?.toLocaleString() }}건</div>
                                <select class="select" v-model.number="state.perPage" @change="changePerPage">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="70">70</option>
                                    <option value="100">100</option>
                                </select>
                                <!-- <div class="change_list_btns">
                                    <button
                                        type="button"
                                        class="list_btn"
                                        :class="state.layer === 0 ? 'on' : ''"
                                        @click="changeLayer(0)"
                                    ></button>
                                    <button
                                        type="button"
                                        class="gal_btn"
                                        :class="state.layer === 1 ? 'on' : ''"
                                        @click="changeLayer(1)"
                                    ></button>
                                </div> -->
                            </div>
                        </div>
                        <div class="gal_list_wrap" :class="state.layer === 1 ? 'card' : ''">
                            <div class="board_cate_btns">
                                <button type="button" @click="removeList">삭제</button>
                                <button type="button" @click="showModal">등록</button>
                            </div>
                            <template v-if="!state.isLoading">
                                <template v-if="result.list.length !== 0">
                                    <ul :class="state.layer === 0 ? 'gal_list' : 'gal_list_v2'">
                                        <li v-for="(item, idx) in result.list">
                                            <div :class="state.layer === 0 ? 'gal_list_con' : 'gal_con'">
                                                <template v-if="state.layer === 0">
                                                    <div>
                                                        <label class="chk">
                                                            <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                            <span></span>
                                                        </label>
                                                    </div>
                                                    <div class="gal_thumb" @click="isDetailModal(item)">
                                                        <div class="gal_thumb_img">
                                                            <img
                                                                :class="{ blur: item.photoUrl }"
                                                                :src="item.photoUrl ? item.photoUrl : require('@/assets/common/NoImg.png')"
                                                                @error="imgError"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="gal_thumb_info_div">
                                                        <ul class="gal_info_list left">
                                                            <li class="gal_info_top">
                                                                <div class="gal_info_tit">
                                                                    <b>순번</b>
                                                                    <span>
                                                                        {{
                                                                            state.currentPage === 1
                                                                                ? idx + 1
                                                                                : state.perPage * (state.currentPage - 1) + idx + 1
                                                                        }}
                                                                    </span>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">고유번호</div>
                                                                <div class="gal_info_con">{{ item.idx }}</div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">플랫폼</div>
                                                                <div class="gal_info_con" v-if="item.platform === 1">Telegram</div>
                                                                <div class="gal_info_con" v-else-if="item.platform === 2">Discord</div>
                                                                <div class="gal_info_con" v-else-if="item.platform === 4">KakaoTalk</div>
                                                                <div class="gal_info_con" v-else>기타</div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">제목</div>
                                                                <div class="gal_info_con" v-html="item.title"></div>
                                                            </li>

                                                            <li>
                                                                <div class="gal_info_tit">링크</div>
                                                                <div class="gal_info_con">
                                                                    <a :href="item.link" target="_blank">{{ item.link }}</a>
                                                                </div>
                                                            </li>

                                                            <li v-if="item.linkForApp">
                                                                <div class="gal_info_tit">App 링크</div>
                                                                <div class="gal_info_con">
                                                                    <a :href="item.linkForApp" target="_blank">{{ item.linkForApp }}</a>
                                                                </div>
                                                            </li>

                                                            <li>
                                                                <div class="gal_info_tit">멤버수</div>
                                                                <div class="gal_info_con" v-html="item.cntMembers?.toLocaleString()"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">등록일자</div>
                                                                <div class="gal_info_con">
                                                                    {{ formatDate(item.createDate) }}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <ul class="gal_info_list right">
                                                            <li class="gal_info_item">
                                                                <p class="gal_info_tit">구분</p>
                                                                <select class="select" v-model="item.gubun">
                                                                    <option :value="0">선택해주세요.</option>
                                                                    <option v-for="option in options.gubun" :value="option.idx">
                                                                        {{ option.name }}
                                                                    </option>
                                                                </select>
                                                            </li>
                                                            <li class="gal_info_item">
                                                                <p class="gal_info_tit">업종</p>
                                                                <select class="select" v-model="item.industry">
                                                                    <option :value="0">선택해주세요.</option>
                                                                    <option v-for="option in options.industry" :value="option.idx">
                                                                        {{ option.name }}
                                                                    </option>
                                                                </select>
                                                            </li>
                                                            <li class="gal_info_item">
                                                                <p class="gal_info_tit">활성화 여부</p>
                                                                <label class="chk">
                                                                    <input
                                                                        type="checkbox"
                                                                        v-model="item.isActive"
                                                                        :true-value="1"
                                                                        :false-value="0"
                                                                    />
                                                                    <span></span>
                                                                </label>
                                                            </li>
                                                            <li class="gal_info_item">
                                                                <p class="gal_info_tit">그루밍 성착취 의심</p>
                                                                <label class="chk">
                                                                    <input
                                                                        type="checkbox"
                                                                        v-model="item.isDoubt"
                                                                        :true-value="1"
                                                                        :false-value="0"
                                                                    />
                                                                    <span></span>
                                                                </label>
                                                            </li>
                                                            <li class="gal_info_item">
                                                                <button type="button" class="deep_blue_btn" @click="modify(item)">
                                                                    저장
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                                <template v-if="state.layer === 1">
                                                    <div class="gal_top_box">
                                                        <div class="gal_top_left">
                                                            <label class="chk">
                                                                <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                                <span></span>
                                                            </label>
                                                        </div>
                                                        <div class="gal_thumb">
                                                            <div class="gal_thumb_img">
                                                                <img
                                                                    :class="{ blur: item.photoUrl }"
                                                                    :src="
                                                                        item.photoUrl ? item.photoUrl : require('@/assets/common/NoImg.png')
                                                                    "
                                                                    @error="imgError"
                                                                    @click="isDetailModal(item)"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="gal_top_txt">
                                                            <div>
                                                                <div class="gal_info_top_box">
                                                                    <p class="gal_info_top">
                                                                        <b>순번</b>
                                                                        <span>
                                                                            {{
                                                                                state.currentPage === 1
                                                                                    ? idx + 1
                                                                                    : state.perPage * (state.currentPage - 1) + idx + 1
                                                                            }}
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="gal_info_div">
                                                        <ul class="gal_info_list">
                                                            <li>
                                                                <div class="gal_info_tit">고유번호</div>
                                                                <div class="gal_info_con">{{ item.idx }}</div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">내용</div>
                                                                <div class="gal_info_con" v-html="item.title"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">링크</div>
                                                                <div class="gal_info_con">
                                                                    <a :href="item.link" target="_blank">{{ item.link }}</a>
                                                                </div>
                                                            </li>
                                                            <li v-if="item.linkForApp">
                                                                <div class="gal_info_tit">App 링크</div>
                                                                <div class="gal_info_con">
                                                                    <a :href="item.linkForApp" target="_blank">{{ item.linkForApp }}</a>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">멤버수</div>
                                                                <div class="gal_info_con" v-html="item.cntMembers?.toLocaleString()"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">등록일자</div>
                                                                <div class="gal_info_con">
                                                                    {{ formatDate(item.createDate) }}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    <NoResult class="result_load"></NoResult>
                                </template>
                                <PageBtn
                                    v-if="result.list.length !== 0 && !state.isLoading"
                                    :currentPage="state.currentPage"
                                    :totalLength="state.totalLength"
                                    :perPage="state.perPage"
                                    @onPaging="handlePageChange"
                                ></PageBtn>
                            </template>
                            <template v-else>
                                <Spinner :isLoading="state.isLoading" class="result_load"></Spinner>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isModalOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
    <SearchRoomModal v-if="addModal.isShow" :isEdit="addModal.isEdit" :info="addModal.info" @close="closeModal"></SearchRoomModal>
</template>
<script lang="ts">
    import {
        apiService,
        Header,
        Menu,
        onMounted,
        reactive,
        returnCode,
        PageBtn,
        formatDate,
        watch,
        userStore,
        NoResult,
        Filter,
        globalStore,
        router,
        Popup,
        Spinner,
        dateFormat,
        watcherbotSearch,
        watcherbotResult,
        SearchRoomModal,
    } from "@/BaseComponent";
    import type { Data } from "@/services/api/searchRoom";
    export default {
        props: [],
        components: {
            Header,
            Menu,
            PageBtn,
            Filter,
            NoResult,
            Popup,
            SearchRoomModal,
            Spinner,
        },
        setup() {
            const global = globalStore();
            const user = userStore();
            // const resultIdx = route.params.idx as any;

            const { changeCode } = returnCode();
            const state = reactive({
                isLoading: true,
                isModalOpen: false,

                checkAll: false as boolean,
                checkList: [] as Array<number>,

                selectOption: [{ idx: 1, text: "내용" }] as Array<any>,
                layer: 0 as number,

                typeList: [] as any,
                detailTypeList: [] as any,
                filterData: {} as any,

                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 100 as number,
            });

            const addModal = reactive({
                isShow: false as boolean,
                info: {} as Data,
                isEdit: false as boolean,
            });

            const result = reactive({
                list: [] as Array<Data>,
                searchInfo: {} as any,
            });
            const modal = reactive({
                title: "" as string,
                content: {
                    title: "" as string,
                    main: {
                        title: "검색정보" as string,
                        data: "" as any,
                        class: "thumb_con",
                        render: (data: any) => {
                            return watcherbotSearch(data);
                        },
                    },
                    subTitle: "검색결과" as string,
                    class: "thumb_con",
                    sub: {
                        title: "" as string,
                        data: "" as any,
                        class: "thumb_con",
                        render: (data: any) => {
                            return watcherbotResult(data);
                        },
                    },
                    img: {
                        data: "" as any,
                        name: "" as any,
                        render: (data: any) => {
                            return data ? data : `<img src="${require("@/assets/common/NoImg.png")}" alt="이미지 없음" />`;
                        },
                    } as any,
                } as any,
            });

            const options = {
                platform: [
                    { idx: 1, name: "Telegram" },
                    { idx: 2, name: "Discord" },
                    { idx: 4, name: "KakaoTalk" },
                    { idx: 3, name: "기타" },
                ],
                gubun: [] as { idx: number; name: string }[],
                industry: [] as { idx: number; name: string }[],
            };

            onMounted(() => {
                global.setSelectMenu(5);
                if (user.perPage) state.perPage = user.perPage;
                if (user.listLayer) state.layer = user.listLayer;

                if (global.gubun.length === 0 && global.industry.length === 0) getTypeList();
                else {
                    options.gubun = global.gubun;
                    options.industry = global.industry;
                    getResultList();
                }
            });

            watch(
                () => state.checkList,
                (newVal) => {
                    state.checkAll = newVal.length === result.list.length;
                },
            );

            const getTypeList = async () => {
                const res = await apiService.ai.getTypeList(1);
                if (res.returnCode === 0) {
                    options.gubun = res.list;
                    global.setGubun(res.list);
                }
                const res2 = await apiService.ai.getTypeList(2);
                if (res2.returnCode === 0) {
                    options.industry = res2.list;
                    global.setIndustry(res2.list);
                }

                getResultList();
            };

            const getResultList = async () => {
                state.isLoading = true;
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: state.filterData.searchType,
                    searchContent: state.filterData.searchContent,
                    platform: state.filterData.platform,
                    ...(state.filterData.gubun ? { gubun: state.filterData.gubun } : {}),
                    ...(state.filterData.industry ? { industry: state.filterData.industry } : {}),
                };
                const res = await apiService.searchRoom.getSearchList(param);
                if (res.returnCode === 0) {
                    result.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 3) {
                    router.replace("/403");
                } else {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            const getsearchDetail = async (idx: number) => {
                const res = await apiService.searchRoom.getSearchDetail(idx);
                if (res.returnCode === 0) {
                    addModal.info = res.data;
                    addModal.isEdit = true;
                    addModal.isShow = true;
                } else {
                    console.warn(changeCode(res.returnCode));
                }
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getResultList();
            };

            const changeLayer = (idx: number) => {
                state.layer = idx;
                user.setListLayer(idx);
            };

            const filterSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getResultList();
            };

            const resetSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getResultList();
            };

            const isDetailModal = (item: any) => {
                getsearchDetail(item.idx);
            };

            const changePerPage = () => {
                user.setPerPage(state.perPage);
                state.currentPage = 1;
                getResultList();
            };

            const closeModal = (data: { result: boolean; info: Data }) => {
                if (data.result) {
                    if (addModal.isEdit) {
                        modify(data.info);
                    } else {
                        add(data.info);
                    }
                } else {
                    addModal.isShow = false;
                    addModal.info = {} as Data;
                }
            };

            const modalClose = () => {
                state.isModalOpen = false;
            };

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/common/NoImg.png");
                }
            };

            const excelDownLoad = async () => {
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: state.filterData.searchType,
                    searchContent: state.filterData.searchContent,
                    platform: state.filterData.platform,
                    ...(state.filterData.gubun ? { gubun: state.filterData.gubun } : {}),
                    ...(state.filterData.industry ? { industry: state.filterData.industry } : {}),
                };
                const res: any = await apiService.searchRoom.downExcelResult(param);

                if (res.status === 200) {
                    try {
                        const blob = res.data;
                        const fileUrl = URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.download = `채팅방리스트.xlsx`;
                        link.href = fileUrl;
                        link.click();
                        URL.revokeObjectURL(fileUrl);
                        return alert("다운로드 완료 되었습니다.");
                    } catch (error) {
                        return alert("다운로드에 실패했습니다.");
                    }
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            const getDetailTypeFilter = (typeIdx: number) => {
                return state.detailTypeList.filter((item: any) => item.typeIdx === typeIdx);
            };

            const toggleAll = () => {
                if (!state.checkAll) {
                    state.checkList = result.list.map((item) => item.idx);
                } else {
                    state.checkList = [];
                }
            };

            const removeList = async () => {
                if (state.checkList.length > 0) {
                    if (confirm("선택한 항목을 삭제하시겠습니까?")) {
                        const param = { idxList: state.checkList.join(",") };
                        const res = await apiService.searchRoom.delResultList(param);
                        if (res.returnCode === 0) {
                            alert("삭제완료 되었습니다.");
                            getResultList();
                        } else {
                            alert(changeCode(res.returnCode));
                        }
                    }
                } else {
                    alert("선택된 항목이 없습니다.");
                }
            };

            const showModal = () => {
                addModal.isEdit = false;
                addModal.isShow = true;
                addModal.info.platform = 0;
            };

            const add = async (info: Data) => {
                const param = {
                    title: info.title,
                    platform: info.platform,
                    link: info.link,
                    description: info.description,
                    isActive: info.isActive,
                    isDoubt: info.isDoubt,
                    gubun: info.gubun,
                    industry: info.industry,
                };
                const res = await apiService.searchRoom.add(param);
                if (res.returnCode === 0) {
                    alert("등록 완료되었습니다.");
                    getResultList();
                    addModal.isShow = false;
                    addModal.info = {} as Data;
                } else {
                    alert("등록 실패했습니다.\n사유 : " + res.description);
                }
            };

            const modify = async (info: Data) => {
                const param = {
                    title: info.title,
                    platform: info.platform,
                    link: info.link,
                    description: info.description,
                    isActive: info.isActive,
                    isDoubt: info.isDoubt,
                    gubun: info.gubun,
                    industry: info.industry,
                };
                const res = await apiService.searchRoom.modify(info.idx, param);
                if (res.returnCode === 0) {
                    alert("수정 완료되었습니다.");
                    getResultList();
                    addModal.isShow = false;
                    addModal.info = {} as Data;
                } else {
                    alert("수정 실패했습니다.\n사유 : " + res.description);
                }
            };

            return {
                state,
                result,
                options,
                handlePageChange,
                formatDate,
                changeLayer,
                filterSearch,
                resetSearch,
                isDetailModal,
                modal,
                modalClose,
                imgError,
                excelDownLoad,
                getDetailTypeFilter,
                toggleAll,
                removeList,
                showModal,
                changePerPage,
                addModal,
                getsearchDetail,
                closeModal,
                modify,
            };
        },
    };
</script>

<style scoped>
    .result_load {
        box-sizing: border-box;
        background-color: #fff;
        position: relative;
        width: 100%;
        max-width: 1600px;
        height: 360px;
    }
    #board_layer .gal_info_list > li .gal_info_con {
        line-height: 1.3;
    }
    #board_layer .gal_list .gal_list_con {
        padding: 25px 0px;
    }
    #board_layer .board_cate_btns {
        left: 300px;
    }
    .board_condition {
        margin-top: 40px;
    }
    .link_app {
        cursor: pointer;
        text-decoration: underline;
    }

    #board_layer .gal_thumb_info_div .gal_info_list:first-child {
        width: 45%;
        border-right: 1px solid #dfdfdf;
    }

    #board_layer .gal_info_list > li .select {
        width: auto;
        padding-right: 35px;
    }

    .gal_info_item .deep_blue_btn {
        border: 1px solid var(--blueFond);
        padding: 0 10px;
        width: 360px;
        height: 34px;
        font-weight: bold;
        font-size: 16px;
        color: #fff;
        background-color: var(--blueFond);
        cursor: pointer;
    }

    #board_layer .gal_thumb_info_div {
        gap: 30px;
    }

    #board_layer .gal_info_list.right > li .gal_info_tit {
        width: 120px;
        margin-right: 0px;
    }
</style>
